(function () {
  function activateLane(root, laneId, moveFocus) {
    if (!root || !laneId) return;
    var activeTab = null;
    root.querySelectorAll('[data-north-lane-tab]').forEach(function (tab) {
      var isActive = tab.dataset.northLaneTab === laneId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive) activeTab = tab;
    });
    root.querySelectorAll('[data-north-lane-panel]').forEach(function (panel) {
      var isActive = panel.dataset.northLanePanel === laneId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
    if (moveFocus && activeTab) activeTab.focus();
  }

  function initLaneSelector(root) {
    if (!root || root.dataset.northLaneReady === 'true') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-north-lane-tab]'));
    if (!tabs.length) return;
    root.dataset.northLaneReady = 'true';
    activateLane(root, (tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0]).dataset.northLaneTab, false);

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-north-lane-tab]');
      if (tab) activateLane(root, tab.dataset.northLaneTab, false);
    });

    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-north-lane-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else index = (index - 1 + tabs.length) % tabs.length;
      activateLane(root, tabs[index].dataset.northLaneTab, true);
    });
  }

  function bindLaneJumps(scope) {
    if (!scope || scope.northLaneJumpReady === true) return;
    scope.northLaneJumpReady = true;
    scope.addEventListener('click', function (event) {
      var link = event.target.closest('[data-north-lane-jump]');
      if (!link) return;
      var lane = link.dataset.northLaneJump;
      var products = document.querySelector('[data-north-products]');
      var filter = products && products.querySelector('[data-market-filter="' + lane + '"]');
      if (filter) filter.click();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-north-lanes]').forEach(initLaneSelector);
    bindLaneJumps(scope || document.body);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
